"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _unescape2 = _interopRequireDefault(require("lodash/unescape"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HotelExperienceCard = _interopRequireDefault(require("../HotelExperienceCard"));
var _HotelExperienceExpanded = _interopRequireDefault(require("../HotelExperienceExpanded"));
var _HotelStars = _interopRequireDefault(require("../HotelStars"));
var _Slider = _interopRequireDefault(require("../Slider"));
var _excluded = ["experiences", "hotelName", "hotelStars", "isMobile"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var HotelExperiencePropTypes = _HotelExperienceCard["default"].HotelExperiencePropTypes;
var createMarkup = function createMarkup(encodedHtml) {
  return {
    __html: (0, _unescape2["default"])(encodedHtml)
  };
};
var HotelExperienceList = function HotelExperienceList(_ref) {
  var experiences = _ref.experiences,
    hotelName = _ref.hotelName,
    hotelStars = _ref.hotelStars,
    isMobile = _ref.isMobile,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    isCollapsing = _useState4[0],
    setCollapsing = _useState4[1];
  var expandedExperience = experiences[index];
  var changeSlide = function changeSlide(newIndex) {
    setCollapsing(true);
    setTimeout(function () {
      setIndex(newIndex);
      setCollapsing(false);
    }, 400);
  };
  return /*#__PURE__*/_react["default"].createElement(StyledHotelExperienceList, (0, _extends2["default"])({
    isMobile: isMobile
  }, props), /*#__PURE__*/_react["default"].createElement(StyledTitle, null, "\u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0432\u043F\u0435\u0447\u0430\u0442\u043B\u0435\u043D\u0438\u044F \u0432 \u043E\u0442\u0435\u043B\u0435", /*#__PURE__*/_react["default"].createElement(StyledHotelName, null, /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    dangerouslySetInnerHTML: createMarkup(hotelName)
  }), !isMobile && /*#__PURE__*/_react["default"].createElement(StyledHotelStars, {
    value: hotelStars,
    size: 11
  }))), expandedExperience && /*#__PURE__*/_react["default"].createElement(_HotelExperienceExpanded["default"], (0, _extends2["default"])({
    isCollapsing: isCollapsing,
    isMobile: isMobile,
    onCollapse: function onCollapse() {
      return changeSlide(null);
    }
  }, expandedExperience)), !(0, _isEmpty2["default"])(experiences) && /*#__PURE__*/_react["default"].createElement(_Slider["default"], {
    controls: !isMobile,
    dots: !isMobile,
    gap: isMobile ? 8 : 20,
    offset: isMobile ? 8 : 20
  }, experiences.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_HotelExperienceCard["default"], (0, _extends2["default"])({
      key: item.title,
      isMobile: isMobile,
      onExpand: function onExpand() {
        return changeSlide(i);
      },
      "data-hidden": i === index
    }, item));
  })));
};
HotelExperienceList.propTypes = {
  className: _propTypes["default"].string,
  experiences: _propTypes["default"].arrayOf(HotelExperiencePropTypes),
  hotelName: _propTypes["default"].string,
  hotelStars: _propTypes["default"].number,
  isMobile: _propTypes["default"].bool
};
HotelExperienceList.defaultProps = {
  className: '',
  experiences: [],
  hotelName: null,
  hotelStars: null,
  isMobile: false
};
var StyledTitle = _styledComponents["default"].h2.withConfig({
  displayName: "HotelExperienceList__StyledTitle",
  componentId: "sc-mdro89-0"
})(["color:", ";"], function (props) {
  return props.theme.colors.blackBase;
});
var StyledHotelName = _styledComponents["default"].span.withConfig({
  displayName: "HotelExperienceList__StyledHotelName",
  componentId: "sc-mdro89-1"
})(["font-weight:normal;"]);
var StyledLabel = _styledComponents["default"].span.withConfig({
  displayName: "HotelExperienceList__StyledLabel",
  componentId: "sc-mdro89-2"
})([""]);
var StyledHotelStars = (0, _styledComponents["default"])(_HotelStars["default"]).withConfig({
  displayName: "HotelExperienceList__StyledHotelStars",
  componentId: "sc-mdro89-3"
})(["margin-left:7px;display:inline;"]);
var StyledHotelExperienceList = _styledComponents["default"].div.withConfig({
  displayName: "HotelExperienceList__StyledHotelExperienceList",
  componentId: "sc-mdro89-4"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
    isMobile = _ref2.isMobile;
  return "\n    padding-bottom: ".concat(isMobile ? 10 : 20, "px;\n    ").concat(StyledTitle, " {\n      ").concat(theme.typography[isMobile ? 'headline3' : 'headline2'], "\n      margin: ").concat(isMobile ? '0 8px 16px' : '0 20px 6px', ";\n    }\n\n    ").concat(StyledHotelName, " {\n      display: ").concat(isMobile ? 'inline' : 'block', ";\n      margin-left: ").concat(isMobile ? 7 : 0, "px;\n    }\n  ");
});
var _default = exports["default"] = HotelExperienceList;